import { bool, oneOf } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { HeadingProperties } from '../heading/heading-types.js';
import { HeadingSectionHeaderBackgroundColor } from './heading-section-constants.js';
const HeadingSectionProperties = {
    ...HeadingProperties,
    headerBackgroundColor: {
        defaultValue: HeadingSectionHeaderBackgroundColor.NONE,
        type: oneOf(enumValues(HeadingSectionHeaderBackgroundColor)),
    },
    hideActions: {
        type: bool.notEnumerable(),
    },
    showCollapseButton: {
        type: bool,
    },
};
export { HeadingSectionProperties, };
//# sourceMappingURL=heading-section-types.js.map